<script>
import { mapActions } from 'pinia';

import { useCommentStore } from '../../../../store/useCommentStore.js';
import * as API from '../../api/comments';
export default {
  name: 'CommentActionButton',
  components: {
    CpButton: require('../../button').default,
    CpBaseSvgIcon: require('../../base-svg-icon').default,
    CpDialog: require('../../dialog').default,
    CpAuthForm: require('../../auth-form/index').default,
    CommentIcon: require('../../social-feed/icons/comment-icon').default,
  },
  props: {
    type: String,
    id: [Number, String],
  },
  methods: {
    ...mapActions(useCommentStore, ['handleDisplayTextEditor']),
  },
};
</script>

<template>
  <div>
    <cp-button noborder @click="handleDisplayTextEditor({type, id})" class="btnClass">
      <cp-base-svg-icon :width="25" :height="25" viewBox="0 0 20 16" icon-color="var(--primary-blue-400)" :stroke-color="'none'">
        <comment-icon />
      </cp-base-svg-icon>
      <span v-if="!$root.isMobile" class="body primary-blue-400-color">Comment</span>
    </cp-button>
  </div>
</template>

<style scoped>
.btnClass {
  background-color: transparent;
}
.button--darkgray-outline {
  transition: color 0.2s ease;
}
.liked {
  color: var(--highlight);
}
</style>
